import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const createBooking = (data) =>
  axios.post(`${API}/bookings`, data).then((r) => r.data);

export const createEnquiry = (data) =>
  axios.post(`${API}/enquiries`, data).then((r) => r.data);

export const createConsultantRequest = (data) =>
  axios.post(`${API}/consultant-requests`, data).then((r) => r.data);

const TEAM_TOKEN_KEY = "ec24_team_token";
export const getTeamToken = () => localStorage.getItem(TEAM_TOKEN_KEY);
export const setTeamToken = (t) =>
  t ? localStorage.setItem(TEAM_TOKEN_KEY, t) : localStorage.removeItem(TEAM_TOKEN_KEY);
const authHdr = () => {
  const t = getTeamToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const adminLogin = (email, password) =>
  axios.post(`${API}/auth/login`, { email, password }).then((r) => r.data);

export const listBookings = () =>
  axios.get(`${API}/bookings`, { headers: authHdr() }).then((r) => r.data);
export const listEnquiries = () =>
  axios.get(`${API}/enquiries`, { headers: authHdr() }).then((r) => r.data);
export const listConsultantRequests = () =>
  axios.get(`${API}/consultant-requests`, { headers: authHdr() }).then((r) => r.data);

export const sendChat = (session_id, message) =>
  axios.post(`${API}/chat`, { session_id, message }).then((r) => r.data);

// Visit reports
export const createVisitReport = (data) =>
  axios.post(`${API}/visit-reports`, data, { headers: authHdr() }).then((r) => r.data);

export const uploadVisitPhoto = (reportId, category, file) => {
  const fd = new FormData();
  fd.append("category", category);
  fd.append("file", file);
  return axios
    .post(`${API}/visit-reports/${reportId}/photos`, fd, {
      headers: { "Content-Type": "multipart/form-data", ...authHdr() },
    })
    .then((r) => r.data);
};

export const listVisitReports = () =>
  axios.get(`${API}/visit-reports`, { headers: authHdr() }).then((r) => r.data);

export const sendReportToGuardian = (reportId) =>
  axios.post(`${API}/visit-reports/${reportId}/send`, {}, { headers: authHdr() }).then((r) => r.data);

export const getSharedReport = (token) =>
  axios.get(`${API}/visit-reports/share/${token}`).then((r) => r.data);

export const fileUrl = (relativeUrl) => `${BACKEND_URL}${relativeUrl}`;

// Hospitals
export const listHospitals = () => axios.get(`${API}/hospitals`).then((r) => r.data);
export const listHospitalsManage = () =>
  axios.get(`${API}/hospitals/manage`, { headers: authHdr() }).then((r) => r.data);
export const publishHospital = (id, published) =>
  axios.post(`${API}/hospitals/${id}/publish`, { published }, { headers: authHdr() }).then((r) => r.data);
export const createHospital = (data) =>
  axios.post(`${API}/hospitals`, data, { headers: authHdr() }).then((r) => r.data);
export const updateHospital = (id, data) =>
  axios.put(`${API}/hospitals/${id}`, data, { headers: authHdr() }).then((r) => r.data);
export const deleteHospital = (id) =>
  axios.delete(`${API}/hospitals/${id}`, { headers: authHdr() }).then((r) => r.data);
export const uploadHospitalImage = (id, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios
    .post(`${API}/hospitals/${id}/image`, fd, {
      headers: { "Content-Type": "multipart/form-data", ...authHdr() },
    })
    .then((r) => r.data);
};

// Emergency requests
export const createEmergency = (data) =>
  axios.post(`${API}/emergency-requests`, data).then((r) => r.data);
export const listEmergency = () =>
  axios.get(`${API}/emergency-requests`, { headers: authHdr() }).then((r) => r.data);

// Associates (careers)
export const createAssociate = (data) =>
  axios.post(`${API}/associates`, data).then((r) => r.data);
export const listAssociates = () =>
  axios.get(`${API}/associates`, { headers: authHdr() }).then((r) => r.data);
